import { render, staticRenderFns } from "./oxPay.vue?vue&type=template&id=64c0e8a9&scoped=true"
import script from "./oxPay.vue?vue&type=script&lang=js"
export * from "./oxPay.vue?vue&type=script&lang=js"
import style0 from "./oxPay.vue?vue&type=style&index=0&id=64c0e8a9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64c0e8a9",
  null
  
)

export default component.exports